<template>
  <div class="view">
    <div class="view__header">
      <h2>Customers</h2>
      <div class="view__header__controls">
        <a
          :href="consumersCSV"
          class="btn btn-brand-primary mb-1"
          target="_blank"
          type="button"
        >Export CSV</a>
      </div>
    </div>
    <div class="view__content">
      <div class="card customers-card">
        <div
          class="table"
          v-if="isConsumerDataReady"
        >
          <div class="table__header">
            <div class="table__header__item">First Name</div>
            <div class="table__header__item">Last Name</div>
            <div class="table__header__item">Email</div>
            <div class="table__header__item">Created</div>
            <div class="table__header__item">Updated</div>
          </div>
          <div class="table__body">
            <div
              :key="index"
              class="table__row"
              v-for="(item, index) in consumerData"
            >
              <div class="table__cell">{{item.first_name}}</div>
              <div class="table__cell">{{item.last_name}}</div>
              <div class="table__cell">{{item.email}}</div>
              <div class="table__cell">{{item.created_at}}</div>
              <div class="table__cell">{{item.updated_at}}</div>
            </div>
          </div>
        </div>
        <div
          class="loading"
          v-else
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api';

export default {
  name: 'consumer-data',
  data() {
    return {
      consumerData: null,
    };
  },
  methods: {},
  computed: {
    isConsumerDataReady() {
      return this.consumerData !== null;
    },
    tableHeaders() {
      return Object.keys(this.consumerData[0]);
    },
    consumersCSV() {
      return `${
        process.env.VUE_APP_SERVICE_API_BASE_URL
      }/getconsumers?business-id=1&to-csv=1`;
    },
  },
  mounted() {
    debugger;
    API.getConsumerData().then((response) => {
      this.consumerData = response.data.data;
    });
  },
  filters: {
    humanizeString(str) {
      return str
        .replace(/^[\s_]+|[\s_]+$/g, '')
        .replace(/[_\s]+/g, ' ')
        .replace(/^[a-z]/, m => m.toUpperCase());
    },
  },
};
</script>

<style lang="scss">
.loading {
  text-align: center;
}
.customers-card {
  grid-column: 1 / end;
}
.table {
  .table__header {
    display: flex;
    background: #e8edf2;
    border-radius: 4px;
    padding: 8px 20px;

    .table__header__item {
      flex: 1;
      font-family: SF Compact Text;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: normal;
      color: #506073;
    }
  }

  .table__body {
    padding-top: 20px;

    .table__row {
      background: #ffffff;
      border: 0.5px solid rgba(64, 87, 120, 0.25);
      box-sizing: border-box;
      box-shadow: 0px 1px 4px rgba(80, 96, 115, 0.1);
      border-radius: 4px;
      display: flex;
      margin-bottom: 8px;
      padding: 16px;

      .table__cell {
        flex: 1;
        font-family: SF Compact Text;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: normal;
        color: #00122b;
      }
    }
  }
}
</style>
